import { render } from "./PurchaseResume.vue?vue&type=template&id=5b8da46e&ts=true"
import script from "./PurchaseResume.vue?vue&type=script&lang=ts"
export * from "./PurchaseResume.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__